export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  DASHBOARD: '/dashboard',
  ADMIN: '/admin',
  ROLES: '/admin/roles',
  AUDIT_LOGS: '/audit-logs',
  REQUEST_LOGS: '/request-logs',
  AUTH_SESSIONS: '/admin/auth/sessions',
  CUSTOMERS: '/customers',
  COMPANIES: '/companies',
  /** Vai trò mặc định của công ty (phân quyền customer đợt 2) */
  COMPANY_ROLE_TEMPLATES: '/company-role-templates',
  DB_SERVERS: '/db-servers',
  PLANS: '/plans',
  MEDIA: '/media',
} as const

/** Trang chi tiết khách hàng; tab trên URL (?tab=info|companies|users|subscription|audit) */
export const customerPath = (id: string, tab?: string) =>
  `/customers/${id}${tab ? `?tab=${tab}` : ''}`

/** Trang chi tiết gói */
export const planPath = (id: string) => `/plans/${id}`

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES]

// Bê từ finiva-admin src/config/routes.ts (cd1de6e)
/**
 * Trang Nhật ký thay đổi đã lọc sẵn, vd { rootTable: 'roles', rootId }. Ra dạng bộ lọc của DataTable
 * trên URL (`filter.rootTable=eq:roles`); khóa `table` cũ đổi thành cột `tableName`.
 */
export const changeLogPath = (params: Record<string, string>) => {
  const query = new URLSearchParams()
  for (const [key, value] of Object.entries(params))
    query.set(`filter.${key === 'table' ? 'tableName' : key}`, `eq:${value}`)
  return `/audit-logs?${query.toString()}`
}
